import { Link } from 'react-router-dom';
import { Star, Tag, Image as ImageIcon } from 'lucide-react';
import { formatPrice } from '@/lib/api';

export const VehicleCard = ({ vehicle, index = 0 }) => {
  const defaultImage = "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800&q=80";
  const mainImage = vehicle.imagenes?.[0] || defaultImage;
  
  // Fix image URL if it's a relative path
  const imageUrl = mainImage.startsWith('/api') 
    ? `${process.env.REACT_APP_BACKEND_URL}${mainImage}`
    : mainImage;

  const saveScrollPosition = () => {
    try {
      const cards = document.querySelectorAll('[data-testid^="vehicle-card-"]');
      sessionStorage.setItem('catalogScroll', JSON.stringify({
        url: window.location.pathname + window.location.search,
        y: window.scrollY,
        count: cards.length,
      }));
    } catch {}
  };

  return (
    <Link
      to={`/vehiculo/${vehicle.slug || vehicle.id}`}
      onClick={saveScrollPosition}
      className="vehicle-card animate-slide-up"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`vehicle-card-${vehicle.id}`}
    >
      {/* Image Container */}
      <div className="image-container">
        <img 
          src={imageUrl}
          alt={vehicle.titulo}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => {
            e.target.src = defaultImage;
          }}
        />
        
        {/* Price Tag */}
        <div className="absolute top-4 right-4 bg-primary text-white font-bold px-3 py-1.5 text-base shadow-lg">
          {formatPrice(vehicle.precio)}
        </div>
        
        {/* Status Badges */}
        <div className="absolute top-4 left-4 flex flex-col gap-1.5">
          {vehicle.destacado && (
            <div className="flex items-center gap-1 bg-black/80 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider">
              <Star className="w-3 h-3 fill-primary text-primary" />
              Destacado
            </div>
          )}
          {vehicle.oferta && (
            <div className="flex items-center gap-1 bg-green-600 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider">
              <Tag className="w-3 h-3" />
              Oferta
            </div>
          )}
        </div>
        
        {/* Condition Badge */}
        {vehicle.condicion && (
          <div className="absolute bottom-4 left-4 bg-secondary/90 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider">
            {vehicle.condicion}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4 flex-1 flex flex-col">
        {/* Internal ID */}
        {vehicle.id_interno && (
          <p className="text-xs font-semibold text-primary uppercase tracking-wider mb-1">
            ID: {vehicle.id_interno}
          </p>
        )}
        {/* Title */}
        <h3 className="font-bold text-base md:text-lg text-foreground line-clamp-2 mb-3 group-hover:text-primary transition-colors">
          {vehicle.titulo}
        </h3>

        {/* Ver más fotos button */}
        <div className="mt-auto pt-2">
          <span className="inline-flex items-center justify-center w-full bg-primary hover:bg-primary/90 text-white text-sm font-bold uppercase tracking-wider px-4 py-2.5 transition-colors">
            <ImageIcon className="w-4 h-4 mr-2" />
            Ver más fotos
          </span>
        </div>
      </div>
    </Link>
  );
};

export const VehicleCardSkeleton = () => {
  return (
    <div className="rounded-sm overflow-hidden bg-card border border-border/50">
      <div className="aspect-[16/9] bg-muted animate-pulse" />
      <div className="p-4 space-y-3">
        <div className="h-5 bg-muted animate-pulse rounded w-3/4" />
        <div className="h-4 bg-muted animate-pulse rounded w-1/2" />
        <div className="grid grid-cols-2 gap-2">
          <div className="h-4 bg-muted animate-pulse rounded" />
          <div className="h-4 bg-muted animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
};
